import {withStyles} from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';

const styles = {
  h1: {
    color: '#444a68',
  },
};

const TitleComponent = ({classes, title}) => {
  return (<h1 className={classes.h1}>{title}</h1>);
};

export const Title = withStyles(styles)(TitleComponent);

TitleComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
};
